<div
  class="edit-screen-title"
  layout="row"
  layout-align="start"
  flex
  >
  <itfg-brand-logo [brand]="client?.brand"></itfg-brand-logo>
  @if (!activeCredit) {
    <span>{{ 'credits.newCredit' | translate }} /
      {{ (client | clientFullName) || '' }}
    </span>
  }

  @if (!!activeCredit) {
    <span>
      {{
      'credits.creditTitleTemplate'
      | translate
      : {
      creditId: activeCredit?.id || '',
      clientFullName: (activeCredit?.user | clientFullName) || ''
    }
    }}
  </span>
}

</div>
<div layout="column">
  <mat-divider style="margin: 10px"></mat-divider>
  <div layout="column">
    <mat-card appearance="outlined" flex>
      <mat-card-title>
        <span [translate]="'clients.clientDetails'"
          >Profile data</span
          >
        </mat-card-title>

        <mat-card-content>
          <div layout="column">
            <div layout="row" layout-wrap>
              <div layout="column" class="flex-padding" flex>
                <mat-form-field>
                  <input matInput type="number" [value]="client?.id" placeholder="{{ 'global.numberSign' | translate }}" readonly>
                  <mat-label>{{ 'global.numberSign' | translate }}</mat-label>
                </mat-form-field>
                <mat-form-field flex>
                  <input matInput type="text" [value]="campaignTag?.name" placeholder="{{ 'global.discountCode' | translate }}" readonly>
                  <mat-label>{{ 'global.discountCode' | translate }}</mat-label>
                  <!-- <mat-label><strong> <span [ngStyle]="{ 'color': campaignTag?.color }">{{ 'global.discountCode' | translate }}</span></strong></mat-label> -->
                </mat-form-field>
              </div>
              <div layout="column" class="flex-padding" flex>
                <mat-form-field flex>
                  <input matInput type="text" [value]="client?.fullName" placeholder="{{ 'global.name' | translate }}" readonly>
                  <mat-label>{{ 'global.name' | translate }}</mat-label>
                </mat-form-field>
                <mat-form-field flex>
                  <input matInput type="text" [value]="client?.civilId" placeholder="{{ 'global.civilId' | translate }}" readonly>
                  <mat-label>{{ 'global.civilId' | translate }}</mat-label>
                </mat-form-field>
              </div>
              <div layout="column" class="flex-padding" flex>
                <mat-form-field flex>
                  <input matInput type="text" [value]="client?.email" placeholder="{{ 'global.email' | translate }}" readonly>
                  <mat-label>{{ 'global.email' | translate }}</mat-label>
                </mat-form-field>
                <mat-form-field flex>
                  <input matInput type="text" [value]="client?.mobile" placeholder="{{ 'clients.mobilePhone' | translate }}" readonly>
                  <mat-label>{{ 'clients.mobilePhone' | translate }}</mat-label>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined" flex>
        <mat-card-title>
          Добави контакт
        </mat-card-title>
        <mat-card-content layout="column">
          @for (contact of addedContacts; track contact) {
            <div layout="row"
              layout-wrap
              layout-align="space-between center"
              >
              <mat-form-field flex class="edit-contact-aditional-padding" >
                <input
                  readonly
                  [value]="contact.phone"
                  matInput
                  type="text"
                  placeholder="{{ 'global.phone' | translate }}"
                  />
                  <mat-label>{{ 'global.phone' | translate }}</mat-label>
                </mat-form-field>
                <mat-form-field flex class="edit-contact-aditional-padding">
                  <input
                    readonly
                    matInput
                    [value]="contact.description"
                    type="text"
                    placeholder="{{ 'clients.description' | translate }}"
                    />
                    <mat-label>{{ 'clients.description' | translate }}</mat-label>
                  </mat-form-field>
                  <div
                    flex
                    layout="row"
                    layout-align="space-between center"
                    class="edit-contact-aditional-padding"
                    >
                    <mat-checkbox
                      [disabled]="true"
                      [checked]="contact.contacted"
                      >
                      <div [translate]="'clients.contacted'">Confirmed contact</div>
                    </mat-checkbox>
                  </div>
                </div>
              }
              <form #contactsFormRef="ngForm"
                layout="row"
                layout-wrap
                layout-align="space-between center"
                [formGroup]="contactsForm"
                (ngSubmit)="onSubmitContact($event);"
                >
                <mat-form-field flex class="edit-contact-aditional-padding" >
                  <input
                    formControlName="phone"
                    itfgPhonePrefix
                    itfgTrimInput
                    matInput
                    type="text"
                    placeholder="{{ 'global.phone' | translate }}"
                    />
                    <mat-label>{{ 'global.phone' | translate }}</mat-label>
                    @if (contactsForm.get('phone').hasError('pattern')) {
                      <mat-error
                        [translate]="'forms.bulgarianPhoneCode'"
                        >Missing 359</mat-error
                        >
                    }
                    @if (contactsForm.get('phone').hasError('minLength')) {
                      <mat-error
                        [translate]="'clients.phoneMinLength'"
                        >Min length 8 symbols</mat-error
                        >
                      }
                      @if (contactsForm.get('phone').hasError('required')) {
                        <mat-error
                          [translate]="'forms.required'"
                          >This field is required</mat-error
                          >
                        }
                      </mat-form-field>
                      <mat-form-field flex class="edit-contact-aditional-padding">
                        <input
                          formControlName="description"
                          matInput
                          itfgTrimInput
                          type="text"
                          placeholder="{{ 'clients.description' | translate }}"
                          />
                          <mat-label>{{ 'clients.description' | translate }}</mat-label>
                          @if (contactsForm.get('description').hasError('required')) {
                            <mat-error
                              [translate]="'forms.required'"
                              >This field is required</mat-error
                              >
                          }
                        </mat-form-field>
                        <div
                          flex
                          layout="row"
                          layout-align="space-between center"
                          class="edit-contact-aditional-padding"
                          >
                          <mat-checkbox
                            formControlName="contacted"
                            >
                            <div [translate]="'clients.contacted'">Confirmed contact</div>
                          </mat-checkbox>
                          <button [disabled]="submitContactDisabled" mat-raised-button type="submit">
                            {{ 'global.save' | translate}}
                          </button>
                        </div>
                      </form>
                    </mat-card-content>
                  </mat-card>
                </div>
                <form #creditFormRef="ngForm" [formGroup]="form" (ngSubmit)="onSubmitCredit($event);" novalidate flex>
                  <mat-card appearance="outlined" flex="100">
                    <mat-card-title>
                      @if (inEditMode) {
                        <span [translate]="'credits.creditParams'"
                          >Credit data</span
                          >
                        }
                        @if (!inEditMode && activeCredit) {
                          <span>
                            <div layout="row">
                              {{
                              'credits.creditTitleTemplate'
                              | translate
                              : {
                              creditId: activeCredit?.id || '',
                              clientFullName: ''
                            }
                            }}
                            <itfg-credit-status-icon [tags]="activeCredit?.tags" [creditStatus]="activeCredit.creditStatus" [showName]="true"></itfg-credit-status-icon>
                          </div>
                        </span>
                      }
                    </mat-card-title>
                    @if (!inEditMode && activeCredit) {
                      <mat-card-subtitle>
                        <span>
                        </span>
                      </mat-card-subtitle>
                    }
                    <mat-card-content>
                      <div flex layout="row" layout-wrap>
                        @if (inEditMode) {
                          <itfg-credit-calculator-form
                            class="right-padding-position-fix"
                            flex-gt-sm="67"
                            flex-gt-md="67"
                            flex="100"
                            [creditCalculatorTemplateCode]="creditCalculatorTemplateCode"
                            [client]="client"
                            (selectedProductPlan)="productPlanChanges($event)"
                          ></itfg-credit-calculator-form>
                        }
                        @if (!inEditMode) {
                          <itfg-credit-calculator-form
                            class="right-padding-position-fix"
                            flex-gt-sm="67"
                            flex-gt-md="67"
                            flex="100"
                            [disableAll]="true"
                            [creditCalculatorTemplateCode]="creditCalculatorCloneTemplateCode"
                            [client]="client"
                            [credit]="activeCredit"
                            [creditToCopy]="activeCredit"
                            (selectedProductPlan)="productPlanChanges($event)"
                          ></itfg-credit-calculator-form>
                        }
                        <mat-card appearance="outlined" flex>
                          <mat-card-content>
                            <div layout="column">
                              @if (inEditMode) {
                                <mat-form-field
                                  flex
                                  class="right-padding-position-fix"
                                  >
                                  <mat-select
                                    placeholder="{{ 'accounts.paymentMethod' | translate }}"
                                    formControlName="payOutPreference"
                                    [compareWith]="comparePaymentOptions"
                                    (selectionChange)="selectedPaymentMethodChange($event)"
                                    required
                                    >
                                    @if (form.value.payOutPreference?.paymentMethod?.name === paymentMethodTypes.BANK) {
                                      <mat-select-trigger>
                                        <span matPrefix
                                          matTooltip="{{ (!!form.value.payOutPreference.bankAccount.verified ? 'global.verified' : 'global.notVerified') | translate }}"
                                          matTooltipPosition="left">
                                          @if (!form.value.payOutPreference.bankAccount.verified) {
                                            <mat-icon class="not-verified-bank-account" style="margin-right: 0;vertical-align: baseline;" fontSet="fa-solid" fontIcon="fa-minus-square"> </mat-icon>
                                          }
                                          @if (!!form.value.payOutPreference.bankAccount.verified) {
                                            <mat-icon class="verified-bank-account" style="margin-right: 0;vertical-align: baseline;" fontSet="fa-solid" fontIcon="fa-check-square"> </mat-icon>
                                          }
                                          {{ form.value.payOutPreference.bankAccount.iban | formatIban:'obfuscated' }}
                                        </span>
                                      </mat-select-trigger>
                                    }
                                    @for (group of paymentMethodGroups; track group) {
                                      <mat-optgroup
                        [label]="
                          group.name | paymentMethodToTranslationKey | translate
                        "
                                        >
                                        @if (
                                          group.name === paymentMethodTypes.BANK) {
                                          @if (group.methods.length === 0) {
                                            <mat-option
                                              class="noClientBankAccounts"
                                              disabled
                                              >
                                              {{ 'clients.noClientBankAccounts' | translate }}
                                            </mat-option>
                                          }
                                          @for (method of group.methods; track method) {
                                            <mat-option
                                              [value]="method"
                                              >
                                              <span matPrefix
                                                matTooltip="{{ (!!method.bankAccount.verified ? 'global.verified' : 'global.notVerified') | translate }}"
                                                matTooltipPosition="left">
                                                @if (!method.bankAccount.verified) {
                                                  <mat-icon class="not-verified-bank-account" style="margin-right: 0;vertical-align: baseline;" fontSet="fa-solid" fontIcon="fa-minus-square"> </mat-icon>
                                                }
                                                @if (!!method.bankAccount.verified) {
                                                  <mat-icon class="verified-bank-account" style="margin-right: 0;vertical-align: baseline;" fontSet="fa-solid" fontIcon="fa-check-square"> </mat-icon>
                                                }
                                                {{ method.bankAccount.iban | formatIban:'obfuscated' }}
                                              </span>
                                            </mat-option>
                                          }
                                          <mat-option
                                            value="createBankAccount"
                                            style="background: #dee3fd17;"
                                            >
                                            <span matPrefix style="margin-right: 8px;">
                                              <mat-icon style="margin-right: 0;vertical-align: baseline;" fontSet="fa-solid" fontIcon="fa-plus"></mat-icon>
                                              Добави сметка
                                            </span>
                                          </mat-option>
                                        } @else {
                                          @for (method of group.methods; track method) {
                                            <mat-option
                                              [value]="method"
                                              >
                                              {{
                                              method.paymentMethod.name
                                              | paymentMethodToTranslationKey
                                              | translate
                                              }}
                                            </mat-option>
                                          }
                                        }
                                      </mat-optgroup>
                                    }
                                  </mat-select>
                                  @if (
                                    form.get('payOutPreference').hasError('required')
                                    ) {
                                    <mat-error
                                      [translate]="'forms.required'"
                                      >This field is required
                                    </mat-error>
                                  }
                                </mat-form-field>
                              }
                              @if (inEditMode) {
                                <mat-form-field>
                                  <input
                                    formControlName="loyaltyPoints"
                                    [min]="minLoyaltyPoints"
                                    [max]="maxLoyaltyPoints"
                                    placeholder="{{ 'clients.loyaltyPoints' | translate }}"
                                    matInput type="number"
                                    [value]="maxLoyaltyPoints"
                                    />
                                    <mat-label>{{ 'clients.loyaltyPoints' | translate }}</mat-label>
                                    @if (
                                      form.get('loyaltyPoints').hasError('min')
                                      ) {
                                      <mat-error
                                        [translate]="'forms.minValue'"
                                        [translateParams]="{ value: minLoyaltyPoints }"
                                        >Min value error
                                      </mat-error>
                                    }
                                    @if (
                                      form.get('loyaltyPoints').hasError('max')
                                      ) {
                                      <mat-error
                                        [translate]="'forms.maxValue'"
                                        [translateParams]="{ value: maxLoyaltyPoints }"
                                        >Max value error
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                }
                                <mat-form-field class="flex-padding" flex style="width: 100%;">
                                  <mat-label>{{ 'communication.note' | translate }}</mat-label>
                                  <textarea matInput
                                    cdkTextareaAutosize
                                    cdkAutosizeMinRows="6"
                                    cdkAutosizeMaxRows="15"
                                    formControlName="note"
                                    itfgAutoScrollTextarea>
                                  </textarea>
                                  @if (form.get('note').hasError('minlength')) {
                                    <mat-error
                                      [translate]="'forms.minLength'"
                                      [translateParams]="{ value: 2 }"
                                      >Min value error
                                    </mat-error>
                                  }
                                  @if (form.get('note').hasError('required')) {
                                    <mat-error
                                    [translate]="'forms.required'">This field is required</mat-error>
                                  }
                                </mat-form-field>
                              </div>
                            </mat-card-content>
                            @if (!inEditMode) {
                              <mat-card-actions>
                                <button type="button" mat-raised-button (click)="saveNote(activeCredit)">{{ 'global.save' | translate }}</button>
                              </mat-card-actions>
                            }
                          </mat-card>
                        </div>
                      </mat-card-content>
                      @if (inEditMode) {
                        <mat-card-actions>
                          <button type="submit" mat-raised-button>{{ 'global.save' | translate }}</button>
                        </mat-card-actions>
                      }
                    </mat-card>
                  </form>
                </div>
